<template>
    <div>
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
        <div class="animated fadeIn">
            <loader v-if="loading"></loader>
            <div v-if="!loading">
                <component-header
                    title="Open Service Tickets"
                    :hasSearch="true"
                    :hasCreate="false"
                    :hasReload="false"
                    :hasback="false"
                   @search-query="onSearch"
                />
                <b-card class="card-wrap mt-2" border-variant="info">
                    <div>
                        <b-table
                            class="rounded-card"
                            :dark="false"
                            :hover="true"
                            :striped="false"
                            :bordered="true"
                            :small="false"
                            :fixed="false"
                            responsive
                            :filter="filter"
                            :items="ticketItemList"
                            :fields="ticketListColumns"
                            :current-page="currentPage"
                            :per-page="perPage"
                            thead-class="header"
                            show-empty
                        >
                            <template slot="cell(empty)">
                                <div v-if="isloading" class="text-center">
                                    <span><b>Loading...</b></span>
                                </div>
                                <div v-else class="text-center">
                                    No data available.
                                </div>
                            </template>

                            <template slot="cell(action)" slot-scope="data">
                                <div class="inline_btnTable">
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle btn-warning"
                                        variant="primary"
                                        @click="editTicket(data.item.restData)"
                                    >
                                        <i class="fas fa-pencil-alt edit"></i>
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <div class="pagination-wrapper">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="ticketItemList.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                            class="justify-content-center justify-content-md-end"
                        ></b-pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";

export default {
    name: "CustomerOpenTickets",
    data() {
        return {
            pageTitle: "",
            filter: "",
            loading: false,
            isloading: false,
            currentPage: 1,
            perPage: 8,
            ticketListColumns: [
                {
                    key: "number",
                    label: "Ticket Number",
                },
                {
                    key: "customerName",
                },
                {
                    key: "category",
                },
                {
                    key: "subject",
                },
                {
                    key: "assignTo",
                    label: "Assigned To",
                },
                {
                    key: "status",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    components: {
        ComponentHeader,
        loader,
        AtomSpinner,
    },
    computed: {
        ...mapGetters({
            getOpenServiceTicket: "serviceticket/GetOpenServiceTicket",
        }),
        ticketItemList() {
            try {
                let data = this.getOpenServiceTicket;
                let ticketList = [];
                if (Array.isArray(data) && data.length > 0) {
                    data.map((obj) => {
                        try {
                            if (obj.status == "OPEN") {
                                let arrObj = {
                                    number: obj.ticketNo,
                                    customerName: obj.reportedBy.name
                                        ? obj.reportedBy.name
                                        : "",
                                    status: obj.status,
                                    category: obj.category
                                        ? obj.category.name
                                        : "-",
                                    subject: obj.subject,
                                    assignTo: obj.assignTo
                                        ? obj.assignTo.name
                                        : "-",
                                    restData: obj,
                                };

                                ticketList.push(arrObj);
                            }
                        } catch (err) {}
                    });
                    return ticketList.sort(
                        (a, b) =>
                            new Date(b.restData.updatedAt) -
                            new Date(a.restData.updatedAt),
                    );
                } else {
                    return [];
                }
            } catch (err) {
                return [];
            }
        },
    },

    methods: {
        handleSearch() {
            if (this.filter) {
                this.filter = ""; // clear search
            }
        },
         onSearch(val) {
        this.filter = val;
        this.currentPage = 1; 
    },
        editTicket(data) {
            this.$router.push({
                name: "edit-service-ticket",
                params: { id: data._id },
            });
        },
    },

    async mounted() {
        this.loading = true;
        const payload = {
            id: "",
        };
        if (this.$currentUserData.category === "SELLER") {
            payload.id = this.$currentUserData._id;
        }
        await this.$store.dispatch(
            "serviceticket/openServiceTicketAction",
            payload,
        );
        this.loading = false;
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
<style scoped>
.search-wrapper {
    position: relative;
    width: 100%;
}

.search-input {
    padding-right: 40px; /* space for icon */
}

.search-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    align-items: center;
}

.search-icon img {
    width: 16px;
    height: 16px;
}

/* Mobile adjustments */
@media (max-width: 576px) {
    .search-input {
        padding-right: 36px;
    }

    .search-icon img {
        width: 14px;
        height: 14px;
    }
}

.rounded-card {
    border-radius: 12px;
}

.btn-warning {
    background: #fe7b08;
    border: #fe7b08;
}

.btn-warning:hover {
    background: #e66a00;
    border-color: #e66a00;
}
</style>
